import { OrganizationIntegrationAccountItem } from "@common/schemas/organization-connection-groups.schema";
import { itemRowId } from "@design-system/ViewTable/grouping/groupByRowTypes";

/**
 * Raw row id for an account item, unique per rendered row. The same financial
 * account can appear under more than one connection (a broken login plus its
 * healthy sibling), and `item.id` is the account id — shared across those rows.
 * Namespacing with the (already-namespaced) connection id keeps each row
 * distinct so selection and the table's `getRowId` don't collapse them.
 */
export const getAccountItemRowId = (
    item: OrganizationIntegrationAccountItem,
): string => `${item.connection.id}:${item.id}`;

/** The table row id (namespaced) an account item selects under. */
export const accountItemRowId = (
    item: OrganizationIntegrationAccountItem,
): string => itemRowId(getAccountItemRowId(item));
